import { Table, Input, Button, DatePicker, Row, Col, Popover } from 'antd/lib';
import React from 'react';
import moment from 'moment';
const { RangePicker } = DatePicker;
import * as Icons from '@ant-design/icons';

class TablaAtenciones extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterDropdownVisible: false,
      verFiltroApellido: false,
      data: this.props.atenciones,
      textoBuscarNombre: '',
      textoBuscarApellido: '',
      textoBuscarDocumento: '',
      filtered: false,
    };
  }

  onInputChange = e => {
    this.setState({ textoBuscarNombre: e.target.value });
  };

  onApellidoChange = e => {
    this.setState({ textoBuscarApellido: e.target.value });
  };

  onDocumentoChange = e => {
    this.setState({ textoBuscarDocumento: e.target.value });
  };

  descargar = () => {
    this.props.onDescargar();
  };

  render() {
    // console.log(this.props);
    const columns = [
      {
        title: 'Tipo Doc',
        dataIndex: ['persona', 'tipo_doc'],
        key: 'tipo_doc',
      },
      {
        title: 'Num Doc',
        dataIndex: ['persona', 'num_doc'],
        key: 'num_doc',
        filterDropdown: (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder="Buscar documento"
              value={this.state.textoBuscarDocumento}
              onChange={this.onDocumentoChange}
              onPressEnter={() =>
                this.props.filtrarPorDocumento(this.state.textoBuscarDocumento)
              }
            />
            <Button
              type="primary"
              onClick={() =>
                this.props.filtrarPorDocumento(this.state.textoBuscarDocumento)
              }
            >
              Buscar Documento
            </Button>
          </div>
        ),
        filterIcon: (
          <Icons.FilterOutlined
            style={{ color: this.state.filtered ? '#108ee9' : '#aaa' }}
          />
        ),
        filterDropdownVisible: this.state.verFiltroDocumento,
        onFilterDropdownVisibleChange: visible => {
          this.setState(
            {
              verFiltroDocumento: visible,
            },
            () => this.searchInput && this.searchInput.focus()
          );
        },
      },
      {
        title: 'Nombre',
        dataIndex: ['persona', 'nombre'],
        key: 'nombre',
        filterDropdown: (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder="Buscar nombre"
              value={this.state.textoBuscarNombre}
              onChange={this.onInputChange}
              onPressEnter={() =>
                this.props.filtrarPorNombre(this.state.textoBuscarNombre)
              }
            />
            <Button
              type="primary"
              onClick={() =>
                this.props.filtrarPorNombre(this.state.textoBuscarNombre)
              }
            >
              Buscar
            </Button>
          </div>
        ),
        filterIcon: (
          <Icons.FilterOutlined
            style={{ color: this.state.filtered ? '#108ee9' : '#aaa' }}
          />
        ),
        filterDropdownVisible: this.state.filterDropdownVisible,
        onFilterDropdownVisibleChange: visible => {
          this.setState(
            {
              filterDropdownVisible: visible,
            },
            () => this.searchInput && this.searchInput.focus()
          );
        },
      },
      {
        title: 'Apellido',
        dataIndex: ['persona', 'apellido'],
        key: 'apellido',
        filterDropdown: (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder="Buscar Apellido"
              value={this.state.textoBuscarApellido}
              onChange={this.onApellidoChange}
              onPressEnter={() =>
                this.props.filtrarPorApellido(this.state.textoBuscarApellido)
              }
            />
            <Button
              type="primary"
              onClick={() =>
                this.props.filtrarPorApellido(this.state.textoBuscarApellido)
              }
            >
              Buscar Apellido
            </Button>
          </div>
        ),
        filterIcon: (
          <Icons.FilterOutlined
            style={{ color: this.state.filtered ? '#108ee9' : '#aaa' }}
          />
        ),
        filterDropdownVisible: this.state.verFiltroApellido,
        onFilterDropdownVisibleChange: visible => {
          this.setState(
            {
              verFiltroApellido: visible,
            },
            () => this.searchInput && this.searchInput.focus()
          );
        },
      },
      {
        title: 'Tipo',
        dataIndex: ['tipo_atencion', 'nombre'],
        key: 'tipo',
      },
      {
        title: 'Fecha',
        dataIndex: 'fecha',
        key: 'fecha',
        render: fecha => moment(fecha).format('DD/MM/YYYY'),
      },
      {
        title: 'Usuario',
        dataIndex: 'creador',
        key: 'creador',
        render: creador => (creador ? creador.apellido.toUpperCase() : '-'),
      },
      {
        title: 'Obs.',
        key: 'observaciones',
        dataIndex: 'observacion',
        render: observacion => (
          <Popover content={observacion} title="Observacion">
            {observacion.length > 50
              ? observacion.slice(0, 75).concat('...')
              : observacion}
          </Popover>
        ),
      },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => (
          <span>
            {/* <Button
              onClick={() =>
                this.props.history.push(`/admin/atenciones/${record._id}`)
              }
            >
              Editar
            </Button>
            <Divider type="vertical" /> */}
            <Button
              size="small"
              type="danger"
              icon={<Icons.EditOutlined />}
              onClick={() => this.props.onDelete(record._id)}
            >
              Eliminar
            </Button>
          </span>
        ),
      },
    ];
    const { atenciones } = this.props;
    return (
      <Table
        rowKey="_id"
        columns={columns}
        pagination={this.props.pagination}
        dataSource={atenciones}
        loading={this.props.loadingTabla}
        title={() => (
          <div>
            {' '}
            <h2 style={{ textAlign: 'center' }}> ATENCIONES </h2>{' '}
            <div style={{ textAlign: 'center' }}>
              {' '}
              <Row>
                <Col span={6}>
                  Cantidad Total de Atenciones: {this.props.pagination.total}
                </Col>
                <Col span={12}>
                  <RangePicker
                    onChange={this.props.onChange}
                    defaultValue={
                      this.props.fechaInicio && this.props.fechaFin
                        ? [
                            moment(this.props.fechaInicio),
                            moment(this.props.fechaFin),
                          ]
                        : [moment().subtract(7, 'd'), moment()]
                    }
                    format={'DD-MM-YYYY'}
                  />
                </Col>{' '}
                <Col span={6}>
                  <Button type="primary" onClick={this.descargar}>
                    <Icons.DownloadOutlined />
                    Descargar Reporte
                  </Button>{' '}
                </Col>{' '}
              </Row>
            </div>{' '}
          </div>
        )}
        locale={{
          emptyText: 'Sin atenciones cargadas.',
        }}
      />
    );
  }
}

export default TablaAtenciones;
